import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const BulletSettingsV1 = z.object({
  bodyText: z.string(),
  centerContent: z.union([z.literal(true), z.literal(false)]),
  iconBackgroundColor: z.string(),
  iconBorderRadius: z.string(),
  iconContainer: z.union([z.literal(true), z.literal(false)]),
  iconPadding: z.string(),
  iconPosition: z.union([
    z.literal("normal"),
    z.literal("flex-start"),
    z.literal("flex-end"),
    z.literal("center"),
    z.literal("start"),
    z.literal("end"),
    z.literal("self-start"),
    z.literal("self-end"),
    z.literal("baseline"),
    z.literal("stretch"),
    z.literal("safe"),
    z.literal("unsafe"),
  ]),
  iconSize: z.string(),
  iconURL: z.string(),
  showBody: z.union([z.literal(true), z.literal(false)]),
  showIcon: z.union([z.literal(true), z.literal(false)]),
  showTextIcon: z.union([z.literal(true), z.literal(false)]),
  showTitle: z.union([z.literal(true), z.literal(false)]),
  smallIcon: z.union([z.literal(true), z.literal(false)]),
  textIcon: z.string(),
  textIconStyle: z.string(),
  titleText: z.string(),
})

export type TBulletSettingsV1 = z.infer<typeof BulletSettingsV1>

export const BulletElementV1 = z.object({
  id: z.string(),
  name: z.literal("bullet"),
  settings: BulletSettingsV1,
  container: ContainerOptionsV1,
})

export type TBulletElementV1 = z.infer<typeof BulletElementV1>

// Latest ---------------------
export const BulletSettings = BulletSettingsV1
export type TBulletSettings = TBulletSettingsV1
export const BulletElement = BulletElementV1
export type TBulletElement = TBulletElementV1
